
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form" @submit.prevent="buscarRelatorios">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="2">
            <v-autocomplete
              label="Turma"
              :items="form.lists.listTurma"
              v-model="form.filters.turmaId"
              outlined
              dense
              item-text="nome"
              item-value="id"
            ></v-autocomplete>
          </v-col>
          <v-col cols="2">
            <v-select
              label="Ano Letivo"
              :items="form.lists.listAnoLetivo"
              v-model="form.filters.anoLetivoId"
              outlined
              dense
              item-text="ano"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-select
              label="Ano/Serie"
              :items="form.lists.listSerie"
              v-model="form.filters.serieId"
              outlined
              dense
              item-text="nome"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-select
              label="Turno"
              :items="form.lists.listTurno"
              v-model="form.filters.turnoId"
              outlined
              dense
              item-text="descricao"
              item-value="id"
            ></v-select>
          </v-col>
          <sca-select-ativo
            :cols="2"
            :config="{
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo',
              label: 'Situação',
            }"
            v-model="form.filters.situacao"
          ></sca-select-ativo>
        </v-row>
        <v-row class="d-flex justify-center mt-0">
          <v-col cols="2">
            <v-text-field
              v-model="form.filters.municipio"
              label="Município"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="form.filters.escola"
              label="Escola"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="form.filters.professor"
              label="Professor"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sca-date-picker
            :cols="2"
            label="Data Início"
            v-model="form.filters.dataInicial"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
          <sca-date-picker
            :cols="2"
            v-model="form.filters.dataFinal"
            label="Data Final"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-submit-button></sca-submit-button>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        show-expand
        :headers="headers"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        :sort-desc="true"
        :expanded.sync="expanded"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="permissoes" :colspan="headers.length">
            <v-chip-group active-class="primary--text" column>
              <v-chip class="chip-permissao">
                Professor(a) de Língua de Portuguesa:&nbsp;<b>{{ item.professorPortugues }}</b>
              </v-chip>
              <v-chip class="chip-permissao">
                Professor(a) de Matemática:&nbsp;<b>{{ item.professorMatematica }}</b>
              </v-chip>
            </v-chip-group>
          </td>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorio('PDF')"
        @cancel="baixarRelatorio('CSV')"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
import RelatorioLogTurma from "~/services/relatorios-log/manter-turmas-log.service";
import AnoLetivoService from "~/services/ano-letivo.service";
import SerieService from "~/services/serie.service";
import TurnoService from "~/services/turno.service";
import DataTableMixin from "~/mixins/datatables.mixin";
import FormatoArquivoEnum from "~/commons/enums/formato-arquivo.enum";
import TurmaService from '~/services/turma.service';
export default {
  name: "RelatorioLogTurma",
  mixins: [
    RelatorioLogTurma,
    DataTableMixin,
    AnoLetivoService,
    TurnoService,
    SerieService,
    TurmaService
  ],
  data: () => ({
    expanded: [],
    form: {
      filters: {
        turmaId: null,
        anoLetivoId: null,
        serieId: null,
        turnoId: null,
        situacao: null,
        municipio: null,
        escola: null,
        professor: null,
        dataInicial: null,
        dataFinal: null,
      },
      lists: {
        listRelatorios: [],
        listAnoLetivo: [],
        listTurno: [],
        listSerie: [],
        listTurma: [],
      }
    },
    headers: [
      { text: "Turma", align: "center", value: "nome" },
      { text: "Ano Letivo", align: "center", value: "anoLetivo.nome" },
      { text: "Ano/Série", align: "center", value: "serie.nome" },
      { text: "Turno", align: "center", value: "turno.nome" },
      { text: "Município", align: "center", value: "municipio" },
      { text: "Escola", align: "center", value: "escola" },
      { text: "Professor", align: "center", value: "data-table-expand" },
      { text: "Qtde. Alunos", align: "center", value: "quantidadeAlunos" },
      { text: "Situação", align: "center", value: "ativo" },
      { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
      { text: "Ação", align: "center", value: "acao" },
    ]
  }),
  methods: {
    async buscarRelatorios() {
      const isValid = this.validarDatas();
      if (!isValid) return;
      if (this.verificarFiltrosPreenchidos()) {
        const { data } = await this.$obterRelatorioLogTurma({ params: this.payload });
        this.form.lists.listRelatorios = [];
        this.expanded = [];
        this.$nextTick(() => this.form.lists.listRelatorios = data.lista);
      }
    },

    verificarFiltrosPreenchidos() {
      if (!this.$temPeloMenosUmNaoNulo(this.form.filters)) {
        return this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
      }
      return true;
    },

    async baixarRelatorio(formato) {
      switch (formato) {
        case FormatoArquivoEnum.CSV:
          return this.baixarRelatorioCSV();
        case FormatoArquivoEnum.PDF:
          return this.baixarRelatorioPDF();
        default:
          return this.$notifyWarning("Formato de relatório inválido.");
      }
    },
    validarDatas() {
      const { dataInicial, dataFinal } = this.form.filters;

      if (dataInicial && dataFinal) {
        if (new Date(dataFinal) < new Date(dataInicial)) {
          this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
          return false;
        }
        if (new Date(dataInicial) > new Date(dataFinal)) {
          this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
          return false;
        }
      }
      return true;
    },
    async baixarRelatorioCSV() {
      const { data } = await this.$obterRelatorioLogCSVTurma({ params: this.form.filters });
      this.$baixarRelatorioCSV(data, `SCA.${this.$options.name}${FormatoArquivoEnum.CSV}`, "Operação realizada com sucesso.");
    },

    async baixarRelatorioPDF() {
      const { data } = await this.$obterRelatorioLogPDFTurma({ params: this.form.filters });
      this.$baixarRelatorioPDF(data, `SCA.${this.$options.name}${FormatoArquivoEnum.PDF}`, "Operação realizada com sucesso.");
    },

    resetForm() {
      this.expanded = [];
      this.$clearFilters(this.form.filters);
      this.form.lists.listRelatorios = [];
    },

    buscarAnoLetivo() {
      this.$buscarAnosLetivos().then(({ data }) => {
        this.form.lists.listAnoLetivo = data.itens;
      });
    },

    buscarTurno() {
      this.$buscarTurnos().then(({ data }) => {
        this.form.lists.listTurno = data.itens;
      });
    },

    buscarSerie() {
      this.$buscarSeries().then(({ data }) => {
        this.form.lists.listSerie = data.itens;
      });
    },
    buscarTurmas() {
      this.$buscarTurmas().then(({ data }) => {
        this.form.lists.listTurma = data.itens
      });
    },
  },
  computed: {
    payload() {
      const payload = { ...this.form.filters };
      return payload;
    }
  },
  mounted() {
    this.buscarTurmas();
    this.buscarAnoLetivo();
    this.buscarTurno();
    this.buscarSerie();
  }
};
</script>
